import InfoIcon from '@mui/icons-material/Info';
import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';
import useTheme from '@/theme/useTheme';

interface InfoTooltipProps {
  text?: string | React.ReactNode;
  children?: React.ReactNode;
  placement?: 'right-start' | 'top' | 'bottom' | 'left' | 'right';
}

const InfoTooltip = ({ text, children, placement = 'right-start' }: InfoTooltipProps) => {
  const { theme } = useTheme();

  return (
    <Tooltip
      title={text ?? children}
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            width: '200px',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'rgba(255,255,255,0.15)',
            bgcolor: '#212129',
            color: '#fff',
            p: '8px',
            display: 'flex',
            flexDirection: 'column',
            gap: `calc(${theme.shape.borderRadius}px * 2)`,
            boxSizing: 'border-box',
            boxShadow: 'none',
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.fontWeightRegular,
          },
        },
      }}
    >
      <Box
        sx={{
          fontSize: '0.75rem',
          color: theme.palette.primary.main,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
          borderRadius: '50%',
          width: 16,
          height: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
          cursor: 'help',
        }}
      >
        ?
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
